// 菜单
const menus = [
  {
    name: "数据统计",
    path: "/jofph/workbench",
    icon: "pie-chart",
  },
  {
    name: "页面编辑",
    path: "/jofph/page",
    icon: "file",
  },
  {
    name: "期刊管理",
    path: "/jofph/journal",
    icon: "book",
    children: [
      {
        name: "年卷期列表",
        path: "/jofph/journal/issue",
      },
      {
        name: "文章列表",
        path: "/jofph/journal/article",
      },
      {
        name: "预印列表",
        path: "/jofph/journal/preprints",
      },
    ],
  },
  {
    name: "特刊管理",
    path: "/jofph/special",
    icon: "exception",
    children: [
      {
        name: "特刊列表",
        path: "/jofph/special/list",
      },
      {
        name: "草稿箱",
        path: "/jofph/special/draft",
      },
    ],
  },
  {
    name: "编委管理",
    path: "/jofph/editor",
    icon: "team",
    children: [
      {
        name: "编委列表",
        path: "/jofph/editor/list",
      },
      {
        name: "草稿箱",
        path: "/jofph/editor/draft",
      },
    ],
  },
  {
    name: "新闻管理",
    path: "/jofph/news",
    icon: "profile",
    children: [
      {
        name: "热点列表",
        path: "/jofph/news/hots",
      },
      {
        name: "公告列表",
        path: "/jofph/news/notice",
      },
      {
        name: "会议列表",
        path: "/jofph/news/meeting",
      },
      {
        name: "合作伙伴",
        path: "/jofph/news/partner",
      },
    ],
  },
  {
    name: "智能工具箱",
    path: "/tools",
    icon: "tool",
    children: [
      {
        name: "收录监测",
        path: "/tools/includeCheck",
      },
      {
        name: "PDF生成",
        path: "/tools/createPDF",
      },
    ],
  },
];

export default menus;
